import * as zod from 'zod';

export default zod.object({
  kind: zod.enum(['break', 'continue']),
});
